import React, { Component, Fragment } from 'react'
import { isEmpty, isNil } from 'ramda'
import { connect } from 'react-redux'
import moment from 'moment'
import { Avatar, Button, Modal, Tag, ToolTip, Div, Span, P, Footer, Header, H2, H5, Section, H6, H3 } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import { getSidebarProperties } from 'api/settings'
import { access } from '@driftt/traffic-control'
import { getAllTags } from 'api/contacts'
import { resolveContactName } from 'utils/contact'

class LeftDetailPane extends Component {
  constructor(props) {
    super(props)

    this.state = {
      settings: null,
      tags: null,
      showUnsubscribeModal: false,
    }
  }

  componentDidMount() {
    this.getSettings()
    this.getTags()
  }

  getSettings = async () => {
    const { orgId } = this.props

    try {
      const {data: settings} = await getSidebarProperties(orgId)

      this.setState({
        settings: JSON.parse(settings.enabledAttributes)
      })
    } catch(e) {
      console.warn(e)
    }
  }

  getTags = async () => {
    try {
      const {data: tags} = await getAllTags()

      this.setState({
        tags
      })
    } catch(e) {
      console.warn(e)
    }
  }

  renderSocial(socialProfile) {
    if (!socialProfile) return null
    const { facebook, linkedin, twitter, location} = socialProfile

    if (isNil(facebook) && isNil(linkedin) && isNil(twitter) && isNil(location)) return null

    return (
      <Fragment>
        <Div className="contact-details--location">
          <Icon name="location-2" width={9}/>{location}
        </Div>
        <Div className="contact-details--social-profiles">
          {(!isNil(facebook) && !isNil(facebook.handle)) && <Div><a href={`http://www.facebook.com/${facebook.handle}`}><Icon name="facebook" width={15} height={15} /></a></Div>}
          {(!isNil(linkedin) && !isNil(linkedin.handle))&& <Div><a href={`http://www.linkedin.com/${linkedin.handle}`}><Icon name="linkedin" width={15} height={15} /></a></Div>}
          {(!isNil(twitter) && !isNil(twitter.handle)) && <Div><a href={`http://www.twitter.com/${twitter.handle}`}><Icon name="twitter" width={15} height={15} /></a></Div>}
        </Div>
      </Fragment>
    )
  }

  determineFieldRender(field) {
    const {contact, properties} = this.props

    if (field === 'tags') {
      return this.renderTagsField();
    }

    let renderedOutput;

    if (contact[field]) {
      renderedOutput = contact[field]
    } else if (contact.attributes[field]) {
      renderedOutput = contact.attributes[field]
    }

    const propertyForField = properties.find(p => p.name === field)
    const propertyType = propertyForField && propertyForField.type;

    if (propertyType === 'DATE' && !!renderedOutput) {
      return this.renderDateField(renderedOutput)
    }

    if (propertyType === 'DATETIME' && !!renderedOutput) {
      return this.renderDateTimeField(renderedOutput)
    }

    if (renderedOutput) {
      return renderedOutput
    } else {
      return this.renderEmptyField()
    }
  }

  renderDateField(dateString) {
    return moment(Number(dateString) || dateString).format('MM/DD/YYYY')
  }

  renderDateTimeField(dateNumber) {
    return moment(dateNumber).format('MM/DD/YYYY')
  }

  renderEmptyField() {
    return (
      <Span className="needs-information">N/A</Span>
    )
  }

  renderTagsField() {
    const {contact} = this.props
    const {tags: allTags} = this.state;

    const contactTags = contact['tags']
    
    if (!contactTags || contact.tags.length === 0 || !allTags) {
      return this.renderEmptyField();
    }

    const tags = contactTags.map(tag => allTags.find(t => t.name === tag))

    return (
      <Div className="about-section-tags">
        {tags.map(tag => <Tag text={tag.displayName} key={tag.name} />)}
      </Div>
    )
  }

  renderUnsubscribeModal = () => {
    const { contact } = this.props
    const { showUnsubscribeModal } = this.state

    return (
      <Modal
        open={showUnsubscribeModal}
        type="warning"
        size="small"
        className="contact-details-unsubscribe-modal"
      >
        <Div className="contact-details-unsubscribe-modal-body">
          <H3>Are you sure?</H3>
          <P type="subtle">
            You are about to unsubscribe {contact.name ? contact.name : contact.email}. This action cannot be undone.
          </P>
        </Div>
        <Footer>
          <Button type="secondary" onClick={this.handleUnsubscribe}>Unsubscribe</Button>
          <Button type="tertiary" onClick={this.hideUnsubscribeModal}>Cancel</Button>
        </Footer>
      </Modal>
    )
  }

  handleUnsubscribe = () => {
    const { updateUnsubscribeStatus } = this.props

    this.hideUnsubscribeModal()
    updateUnsubscribeStatus()
  }

  hideUnsubscribeModal = () => {
    this.setState({
      showUnsubscribeModal: false
    })
  }

  showUnsubscribeModal = () => {
    this.setState({
      showUnsubscribeModal: true
    })
  }

  render() {
    const { settings } = this.state
    const { contact, updateFollowStatus, unsubscribed, following, onEnrollInSequence, sequenceName, unenrollFromSequence, hasEnrollInSequence, isOutreachConnected } = this.props

    const isActiveSalesSequenceOrg = access.hasGates('is_active_sales_sequence_org')

    const shouldShowEnrollInSequenceButton = hasEnrollInSequence && (isOutreachConnected || isActiveSalesSequenceOrg)

    return (
      <Fragment>
        <Header className="contact-details-left-header">
          <Div>
            {!isEmpty(contact) && <Avatar user={contact} className="contact-details-avatar"/> }
          </Div>
          <Div className="contact-details--top-info">
            <H2>{resolveContactName(contact)}</H2>
            <H5 className="contact-details--contact-email">{contact.email}</H5>
            {!isEmpty(contact.socialProfile) &&
              this.renderSocial(contact.socialProfile)
            }
          </Div>
        </Header>
        {this.renderUnsubscribeModal()}
        <Section className="contact-details-action-buttons">
          {shouldShowEnrollInSequenceButton && (sequenceName ?
            <ToolTip
              flow="up"
              component={`Sequence: ${sequenceName}`}>
              <Button type="tertiary" className="contact-details-enroll-in-sequence" onClick={unenrollFromSequence}>Unenroll from Sequence</Button>
            </ToolTip> :
           <Button type="secondary" className="contact-details-enroll-in-sequence" onClick={onEnrollInSequence}>Enroll in sequence</Button>
          )}
          <Div className="contact-details-action-buttons--split">
            <Button type={`${following ? 'tertiary' : 'subtle'}`} icon={`${following ? 'check' : 'plus'}`} onClick={() => updateFollowStatus()}>{`${following ? 'Following' : 'Follow'}`}</Button>
            <Button type="subtle" disabled={unsubscribed} onClick={this.showUnsubscribeModal}>{`${unsubscribed ? 'Unsubscribed' : 'Unsubscribe'}`}</Button>
          </Div>
        </Section>
        <Section className="contact-details-about-section">
          <Div className="contact-details-about-section-headline">
            <Div className="contact-details-about-section-headline-icon">
              <Icon name="rolodex" width={15} />
            </Div>
            <Div className="contact-details-about-section-headline-text">
              <H6>About</H6>
            </Div>
          </Div>
          <Div className="contact-details-about-section-scroll">
            {!!settings && settings.map(field => {
              return (
                <Div className="about-section-detail-row" key={`about-section--${field}`}>
                  <Div className="about-section-detail-heading">{field}</Div>
                  <Div className="about-section-detail-value">{this.determineFieldRender(field)}</Div>
                </Div>
              )
            })}
          </Div>
        </Section>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isOutreachConnected: state?.integrations?.status?.outreach
  }
}

export default connect(mapStateToProps, null)(LeftDetailPane)
